import {Link} from 'react-router-dom';

const SponsorHeaderText = () => {
  return (
    <div className="flex flex-col items-end">
      <p className="mb-2">
        پیش‌آگاهی و هشدارهای مزرعه یکی از خدمات ویژه و محبوب سامانه است. پیشنهاد
        ما به شما این است که به عنوان تبلیغات و برندینگ هوشمند، هزینه ارسال
        پیام‌های پیش‌آگاهی را بر عهده بگیرید. این همکاری یک پیشنهاد جذاب و
        ارزنده است که به برندینگ شما کمک شایانی خواهد کرد.
      </p>
      <Link to="/sponsor/old-plan" className="no-underline text-farm-shop-500">
        مشاهده طرح‌های قبلی
      </Link>
    </div>
  );
};

export default SponsorHeaderText;
